import type {
    ButtonEvent,
    InputEvent,
    InputChannel,
} from 'virtual-tour-viewer/src/modules/React360Proxy';

/**
 * This class is very similar to react-360's KeyboardInputChannel implementation
 * with one exception: Instead of being hardcoded to listen to all keyboard
 * events on the `window` object, this implementation allows the user to
 * specify the scope in which the InputChannel will listen by providing an
 * HTMLElement as the eventLayer.
 */
export default class EventLayerKeyboardInputChannel implements InputChannel {
    _batchedEvents: Array<ButtonEvent>;
    _mapping: Array<?string>;

    constructor(eventLayer: HTMLElement, customMapping: Array<?string> = []) {
        this._batchedEvents = [];
        this._mapping = [];
        this._mapping[13] = 'confirm'; // Enter
        this._mapping[32] = 'confirm'; // Spacebar
        for (let key = 0, len = customMapping.length; key < len; key++) {
            if (key in customMapping) {
                this._mapping[key] = customMapping[key];
            }
        }
        (this: any)._onKeyDown = this._onKeyDown.bind(this);
        (this: any)._onKeyUp = this._onKeyUp.bind(this);

        eventLayer.addEventListener('keydown', this._onKeyDown, true);
        eventLayer.addEventListener('keyup', this._onKeyUp, true);
    }

    _onKeyDown(e: KeyboardEvent) {
        const code = e.keyCode;
        if (!code) {
            return;
        }
        const event: ButtonEvent = {
            type: 'button',
            button: code,
            action: e.repeat ? 'repeat' : 'down',
            source: 'keyboard',
        };
        const buttonClass = this._mapping[code];
        if (buttonClass) {
            event.buttonClass = buttonClass;
        }
        this._batchedEvents.push(event);
    }

    _onKeyUp(e: KeyboardEvent) {
        const code = e.keyCode;
        if (!code) {
            return;
        }
        const event: ButtonEvent = {
            type: 'button',
            button: code,
            action: 'up',
            source: 'keyboard',
        };
        const buttonClass = this._mapping[code];
        if (buttonClass) {
            event.buttonClass = buttonClass;
        }
        this._batchedEvents.push(event);
    }

    getEvents(acc: Array<InputEvent>): void {
        const events = this._batchedEvents;
        for (let i = 0, len = events.length; i < len; i++) {
            acc.push(events[i]);
        }
        events.length = 0;
    }
}
